__turbopack_context__.v({
  "container": "_0W96Va_container",
  "slider": "_0W96Va_slider",
  "sliderWrapper": "_0W96Va_sliderWrapper",
});
